var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDailyTipsButton)?_c('DailyTips',[_c('div',{staticClass:"base-tooltip cursor-pointer d-flex justify-content-center align-items-center",attrs:{"data-tooltip":_vm.$t('titles.dailyTips')}},[_c('Tips')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }